import { loadableReady } from "@loadable/component";
import React, { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import { RENDERER_OPTIONS } from "./hooks/useRender";

loadableReady(
  async () => {
    const { default: markdownIt } = await import("markdown-it");
    const md = markdownIt(RENDERER_OPTIONS);

    globalThis.__renderer = (src) => md.render(src);
    globalThis.__renderToString = (el) => {
      const div = document.createElement("div");
      const root = createRoot(div);

      try {
        root.render(el);
        const html = div.innerHTML;
        return html;
      } finally {
        setTimeout(() => {
          root.unmount();
        });
      }
    };

    hydrateRoot(
      document.getElementById("browse-content-root")!,
      <StrictMode>
        <App {...window.__browse_content_initial_state__} brand={window.universal_variable.brand} />
      </StrictMode>,
    );
  },
  { namespace: "__PLP_CONTENT_FE" },
);
